import LangEnum from '../../../../../lang/LangEnum';
import { StatusType } from '../../../order.types';
import { ChangeOrderStatusModalAcceptedStatus } from '../changeOrderStatusModal.types';

export const CHANGE_ORDER_REASON_MAX_LENGTH = 60;

export const CHANGE_ORDER_STATUS_MODAL_TITLE_BASED_ON_TARGET_STATUS: Record<
  ChangeOrderStatusModalAcceptedStatus,
  LangEnum
> = {
  [StatusType.CANCELED]: LangEnum.CHANGE_ORDER_STATUS_MODAL_TITLE_CANCELED,
  [StatusType.REJECTED]: LangEnum.CHANGE_ORDER_STATUS_MODAL_TITLE_REJECTED,
};

export const CHANGE_ORDER_STATUS_MODAL_CONFIRM_BASED_ON_TARGET_STATUS: Record<
  ChangeOrderStatusModalAcceptedStatus,
  LangEnum
> = {
  [StatusType.REJECTED]: LangEnum.GLOBAL_REPROVE,
  [StatusType.CANCELED]: LangEnum.GLOBAL_CANCEL_LABEL,
};
